import * as React from "react";
import { EditorTools, EditorToolsSettings } from "@progress/kendo-react-editor";

const fontSizeToolSettings = {
  ...EditorToolsSettings.fontSize,
  defaultItem: {
    // localizationKey: "editor.fontSize",
    text: "Size",
    value: "",
  },
  items: Array.from({ length: 27 }, (_, i) => ({
    text: `${i + 10}`,
    value: `${i + 10}pt`,
  })),
};

// Creates custom FontSize tool.
const CustomFontSize = EditorTools.createStyleDropDownList(fontSizeToolSettings);

// Styles the FontSize tool (DropDownList).
const CustomFontSizeTool = (props) => {
  return (
    <CustomFontSize
      {...props}
      style={{
        width: "70px",
        ...props.style,
      }}
    />
  );
};
export default CustomFontSizeTool;
